export default __webpack_public_path__ + "static/media/bananana.79da2340.mp3";